'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _throttle3 = require('lodash/throttle');

var _throttle4 = _interopRequireDefault(_throttle3);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _audioplayer = require('redux/modules/audioplayer');

var audioPlayerActions = _interopRequireWildcard(_audioplayer);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _reactDraggable = require('react-draggable');

var _reactDraggable2 = _interopRequireDefault(_reactDraggable);

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _auth = require('selectors/auth');

var _Albums = require('helpers/Albums');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./AudioPlayer.scss');

var cn = _bind2.default.bind(styles);

var AudioPlayer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    album: state.audioplayer.album,
    currentTrackIndex: state.audioplayer.currentTrackIndex,
    expanded: state.audioplayer.expanded,
    humanizedPosition: state.audioplayer.humanizedPosition,
    isAlbumDenied: state.audioplayer.isAlbumDenied,
    isAlbumEnded: state.audioplayer.isAlbumEnded,
    lastAlbum: state.audioplayer.lastAlbum,
    lastTracks: state.audioplayer.lastTracks,
    playerStatus: state.audioplayer.playerStatus,
    playlistKey: (0, _get4.default)(state, 'playlist.playlistActionData.key'),
    position: state.audioplayer.position,
    tracks: state.audioplayer.tracks,
    user: (0, _auth.getUser)(state),
    volume: state.audioplayer.volume
  };
}, (0, _extends3.default)({}, audioPlayerActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AudioPlayer, _Component);

  function AudioPlayer() {
    var _ref;

    (0, _classCallCheck3.default)(this, AudioPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AudioPlayer.__proto__ || (0, _getPrototypeOf2.default)(AudioPlayer)).call.apply(_ref, [this].concat(args)));

    _this.onVolumeDrag = (0, _throttle4.default)(function (e, position, progress) {
      _this.props.setVolume(progress);
    }, 200);

    _this.isPreventUppdatePosition = false;
    _this.isPreventUppdateVolume = false;
    _this.seekStartPosition = 0;
    return _this;
  }

  (0, _createClass3.default)(AudioPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.setVolume(_AudioPlayer2.default.volume());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          isAlbumDenied = _props.isAlbumDenied,
          isAlbumEnded = _props.isAlbumEnded;

      if (nextProps.isAlbumEnded && !isAlbumEnded && this.endModal) {
        this.endModal.open();
      }
      if (nextProps.isAlbumDenied && !isAlbumDenied && this.deniedModal) {
        this.deniedModal.open();
      }
    }
  }, {
    key: 'onVolumeInit',
    value: function onVolumeInit() /*position, progress*/{
      // this.props.setVolume(progress);
    }
  }, {
    key: 'onVolumeDragStart',
    value: function onVolumeDragStart(e, position, progress) {
      this.isPreventUppdateVolume = true;
      this.props.setVolume(progress);
    }
  }, {
    key: 'onVolumeDragStop',
    value: function onVolumeDragStop(e, position, progress) {
      this.isPreventUppdateVolume = false;
      this.props.setVolume(progress);
    }
  }, {
    key: 'onSeekDragStart',
    value: function onSeekDragStart(e, position, progress) {
      this.isPreventUppdatePosition = true;
      this.seekStartPosition = progress;
      this.seek(progress, true);
    }
  }, {
    key: 'onSeekDragStop',
    value: function onSeekDragStop(e, position, progress) {
      this.isPreventUppdatePosition = false;
      if (this.seekStartPosition !== progress) {
        this.seek(progress, false);
      }
    }
  }, {
    key: 'getCurrentDuration',
    value: function getCurrentDuration() {
      var _props2 = this.props,
          tracks = _props2.tracks,
          currentTrackIndex = _props2.currentTrackIndex;

      var duration = Number((0, _get4.default)(tracks, [currentTrackIndex, 'duration'], 0));
      var audio = _AudioPlayer2.default.audio;
      if (!duration && audio) {
        duration = audio.duration;
      }
      return duration;
    }
  }, {
    key: 'volumeDown',
    value: function volumeDown() {
      this.props.setVolume(0, true);
    }
  }, {
    key: 'volumeUp',
    value: function volumeUp() {
      this.props.setVolume(1, true);
    }
  }, {
    key: 'seek',
    value: function seek(progress) {
      var duration = this.getCurrentDuration();
      var sec = duration * progress;
      this.props.seek(sec);
    }
  }, {
    key: 'goPlaylist',
    value: function goPlaylist() {
      var _props3 = this.props,
          pushState = _props3.pushState,
          contentKey = _props3.album.contentKey;

      if (contentKey) {
        pushState('/playlists/fromkey/' + contentKey);
      }
    }
  }, {
    key: 'replay',
    value: function replay() {
      var _props4 = this.props,
          playAlbum = _props4.playAlbum,
          album = _props4.lastAlbum,
          tracks = _props4.lastTracks;

      this.endModal.close();
      playAlbum({ album: album, tracks: tracks });
    }
  }, {
    key: 'isTrackLoaded',
    value: function isTrackLoaded() {
      var _props5 = this.props,
          tracks = _props5.tracks,
          currentTrackIndex = _props5.currentTrackIndex;

      return !!tracks[currentTrackIndex];
    }
  }, {
    key: 'playPrev',
    value: function playPrev() {
      if (this.isTrackLoaded()) {
        this.props.playPrev();
      }
    }
  }, {
    key: 'playNext',
    value: function playNext() {
      if (this.isTrackLoaded()) {
        this.props.playNext();
      }
    }
  }, {
    key: 'playPause',
    value: function playPause() {
      if (this.isTrackLoaded()) {
        this.props.playPause();
      }
    }
  }, {
    key: 'renderFull',
    value: function renderFull() {
      var _props6 = this.props,
          playerStatus = _props6.playerStatus,
          tracks = _props6.tracks,
          currentTrackIndex = _props6.currentTrackIndex,
          album = _props6.album,
          volume = _props6.volume,
          humanizedPosition = _props6.humanizedPosition,
          position = _props6.position,
          expanded = _props6.expanded,
          className = _props6.className,
          toggleExpand = _props6.toggleExpand;

      var positionProgress = position / this.getCurrentDuration();
      var playerTrack = tracks[currentTrackIndex];
      var playBtnClass = (0, _bind2.default)(styles.control, styles.playBtn, 'dragStop', playerStatus === _AudioPlayer2.default.status.play ? 'icon-pause' : 'icon-play');
      var trackLoaded = this.isTrackLoaded();

      return _react2.default.createElement(
        _reactDraggable2.default,
        { cancel: '.dragStop', bounds: 'html', onStart: function onStart(e) {
            return e.preventDefault();
          } },
        !expanded || !trackLoaded ? _react2.default.createElement('div', null) : _react2.default.createElement(
          'div',
          { className: cn('audioPlayer', 'full', className) },
          _react2.default.createElement('i', { type: 'button', className: (0, _bind2.default)('icon-close', styles.closer, 'dragStop'), onClick: toggleExpand }),
          _react2.default.createElement(
            'div',
            { className: styles.coverContainer },
            _react2.default.createElement(_components.Thumb, { className: styles.cover, fileName: album.imageThumb, defaultImageName: (0, _Albums.getDefaultImageName)(album) })
          ),
          trackLoaded && _react2.default.createElement(
            'div',
            { onClick: this.goPlaylist, className: (0, _bind2.default)(styles.title, 'dragStop') },
            _react2.default.createElement(
              'div',
              { className: styles.trackName },
              playerTrack.trackName
            ),
            _react2.default.createElement(
              'div',
              { className: styles.artistName },
              album.artist_name
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.controls },
            _react2.default.createElement('i', { className: (0, _bind2.default)('icon-previous pull-left dragStop', styles.control), onClick: this.playPrev }),
            _react2.default.createElement('i', { className: (0, _bind2.default)('icon-next pull-right dragStop', styles.control), onClick: this.playNext }),
            _react2.default.createElement('i', { className: playBtnClass, onClick: this.playPause })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.seek },
            _react2.default.createElement(
              'div',
              { className: cn(styles.duration) },
              humanizedPosition
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _bind2.default)(styles.seekBar, 'dragStop') },
              _react2.default.createElement(_components.DragBar, {
                value: positionProgress,
                forceUpdate: !this.isPreventUppdatePosition,
                onStart: this.onSeekDragStart,
                onStop: this.onSeekDragStop,
                progressBarClass: styles.seekProgressBar,
                hideProgress: true
              })
            ),
            _react2.default.createElement(
              'div',
              { className: cn(styles.duration) },
              playerTrack.durationTime
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.volume },
            _react2.default.createElement('i', { className: (0, _bind2.default)('icon-sound', styles.volumeDown) }),
            _react2.default.createElement(
              'div',
              { className: cn(styles.volumeBar, 'dragStop') },
              _react2.default.createElement(_components.DragBar, {
                value: volume,
                forceUpdate: !this.isPreventUppdateVolume,
                onInit: this.onVolumeInit,
                onStart: this.onVolumeDragStart,
                onStop: this.onVolumeDragStop,
                onDrag: this.onVolumeDrag,
                progressBarClass: styles.volumeProgressBar,
                hideProgress: true
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderLine',
    value: function renderLine() {
      var _props7 = this.props,
          playerStatus = _props7.playerStatus,
          tracks = _props7.tracks,
          currentTrackIndex = _props7.currentTrackIndex,
          album = _props7.album,
          toggleExpand = _props7.toggleExpand,
          expanded = _props7.expanded,
          position = _props7.position,
          t = _props7.t,
          volume = _props7.volume,
          humanizedPosition = _props7.humanizedPosition,
          className = _props7.className;

      var playerTrack = tracks[currentTrackIndex];
      var trackLoaded = this.isTrackLoaded();
      var playBtnClass = (0, _bind2.default)(styles.control, styles.playBtn, playerStatus === _AudioPlayer2.default.status.play ? 'icon-pause' : 'icon-play', (0, _defineProperty3.default)({}, styles.inactive, !trackLoaded));
      var expandIconClass = expanded ? 'icon-collapse' : 'icon-zoom';
      var positionProgress = position / this.getCurrentDuration();

      return _react2.default.createElement(
        'div',
        { className: cn('audioPlayer', 'line', className, { inactive: !trackLoaded }) },
        _react2.default.createElement(
          'div',
          { className: cn('controls', 'cell') },
          _react2.default.createElement('i', { className: (0, _bind2.default)('icon-previous pull-left', styles.control, (0, _defineProperty3.default)({}, styles.inactive, !trackLoaded)), onClick: this.playPrev }),
          _react2.default.createElement('i', { className: playBtnClass, onClick: this.playPause }),
          _react2.default.createElement('i', { className: (0, _bind2.default)('icon-next pull-right', styles.control, (0, _defineProperty3.default)({}, styles.inactive, !trackLoaded)), onClick: this.playNext })
        ),
        trackLoaded && _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(_components.Thumb, {
            className: cn('cover', 'cell'),
            fileName: album.imageThumb,
            onClick: this.goPlaylist,
            defaultImageName: (0, _Albums.getDefaultImageName)(album)
          }),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: cn(styles.trackName, 'text-overflow'), title: playerTrack.trackName },
                playerTrack.trackName
              ),
              _react2.default.createElement(
                'div',
                { className: cn(styles.artistName, 'text-overflow'), title: album.artist_name },
                album.artist_name
              ),
              _react2.default.createElement(
                'div',
                { className: styles.times },
                humanizedPosition,
                ' / ',
                playerTrack.durationTime
              )
            ),
            _react2.default.createElement(_components.DragBar, {
              className: styles.seekBar,
              value: positionProgress,
              forceUpdate: !this.isPreventUppdatePosition,
              onStart: this.onSeekDragStart,
              onStop: this.onSeekDragStop,
              progressBarClass: styles.seekProgressBar,
              hideProgress: true
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.volumeContainer },
            _react2.default.createElement('i', { className: (0, _bind2.default)('icon-sound', styles.volumeIcon) }),
            _react2.default.createElement(_components.DragBar, {
              className: styles.volumeBar,
              value: volume,
              forceUpdate: !this.isPreventUppdateVolume,
              onInit: this.onVolumeInit,
              onStart: this.onVolumeDragStart,
              onStop: this.onVolumeDragStop,
              onDrag: this.onVolumeDrag,
              progressBarClass: styles.volumeProgressBar,
              hideProgress: true
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.expander, onClick: toggleExpand, title: t('Click to pop out') },
            _react2.default.createElement('i', { className: expandIconClass })
          )
        ),
        this.renderEndModal(),
        this.renderDeniedModal()
      );
    }
  }, {
    key: 'renderEndModal',
    value: function renderEndModal() {
      var _this2 = this;

      var t = this.props.t;

      var modalProps = {
        backdrop: 'static',
        closeByEsc: false,
        title: t('Session complete'),
        bsSize: 'lg',
        className: styles.endModal
      };

      return _react2.default.createElement(
        _components.Modal,
        (0, _extends3.default)({ ref: function ref(el) {
            return _this2.endModal = el;
          } }, modalProps),
        _react2.default.createElement(
          'h3',
          { className: styles.title },
          t('Play again?')
        ),
        _react2.default.createElement(
          'div',
          { className: 'text-center margin-top-20' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-humble margin-top-10', onClick: function onClick() {
                return _this2.endModal.close();
              } },
            t('No')
          ),
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary margin-left-20 margin-top-10', onClick: this.replay },
            t('Yes')
          )
        )
      );
    }
  }, {
    key: 'renderDeniedModal',
    value: function renderDeniedModal() {
      var _this3 = this;

      var _props8 = this.props,
          t = _props8.t,
          flushAlbumDeniedFlag = _props8.flushAlbumDeniedFlag;

      var modalProps = {
        backdrop: true,
        closeByEsc: true,
        title: t('Warning'),
        bsSize: 'lg',
        className: styles.endModal,
        onHide: flushAlbumDeniedFlag
      };

      return _react2.default.createElement(
        _components.Modal,
        (0, _extends3.default)({ ref: function ref(el) {
            return _this3.deniedModal = el;
          } }, modalProps),
        _react2.default.createElement(
          'h3',
          { className: styles.title },
          t('You have exceeded the maximum number of allocated plays')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var view = this.props.view;


      switch (view) {
        case 'line':
          return this.renderLine();
        case 'full':
        default:
          return this.renderFull();
      }
    }
  }]);
  return AudioPlayer;
}(_react.Component), _class3.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string,
  currentTrackIndex: _propTypes2.default.number,
  expanded: _propTypes2.default.bool,
  flushAlbumDeniedFlag: _propTypes2.default.func,
  humanizedPosition: _propTypes2.default.string,
  isAlbumDenied: _propTypes2.default.bool,
  isAlbumEnded: _propTypes2.default.bool,
  lastAlbum: _propTypes2.default.object,
  lastTracks: _propTypes2.default.array,
  playAlbum: _propTypes2.default.func,
  playerStatus: _propTypes2.default.string,
  playlistKey: _propTypes2.default.string,
  playNext: _propTypes2.default.func,
  playPause: _propTypes2.default.func,
  playPrev: _propTypes2.default.func,
  position: _propTypes2.default.number,
  pushState: _propTypes2.default.func,
  seek: _propTypes2.default.func,
  setVolume: _propTypes2.default.func,
  t: _propTypes2.default.func,
  toggleExpand: _propTypes2.default.func,
  tracks: _propTypes2.default.array,
  user: _propTypes2.default.object,
  view: _propTypes2.default.string,
  volume: _propTypes2.default.number
}, _class3.defaultProps = {
  view: 'full'
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onVolumeInit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVolumeInit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onVolumeDragStart', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVolumeDragStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onVolumeDragStop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVolumeDragStop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSeekDragStart', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSeekDragStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSeekDragStop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSeekDragStop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'volumeDown', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'volumeDown'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'volumeUp', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'volumeUp'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'goPlaylist', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'goPlaylist'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'replay', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'replay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playPrev', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playPrev'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playNext', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playNext'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playPause', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playPause'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = AudioPlayer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AudioPlayer/AudioPlayer.js
// module id = 1951
// module chunks = 1